import { Component, OnInit } from '@angular/core';
declare var $: any;
@Component({
  selector: 'app-absence-assignment',
  templateUrl: './absence-assignment.component.html',
  styleUrls: ['./absence-assignment.component.scss']
})
export class AbsenceAssignmentComponent implements OnInit {

  absenceRequests:any;
  showLoader:boolean=false;
  constructor() { }

  ngOnInit(): void {
    this.absenceRequests = [
      {
        id: "10",
        student: "441-Student",
        primTeacher: "01-SEP-2020",
        secnTeacher: "01-SEP-2020",
        remarks: "Text 1234",
        statusFlag: "Accepted",
        assignmentDesc:"",
        assiignmentFilename:"",
        answerDesc:"",
        answerFilename:"",
      },
      {
        id: "10",
        student: "441-Student",
        primTeacher: "01-SEP-2020",
        secnTeacher: "01-SEP-2020",
        remarks: "Text 1234",
        statusFlag: "Accepted",
        assignmentDesc:"",
        assiignmentFilename:"",
        answerDesc:"",
        answerFilename:"",
      },
      {
        id: "10",
        student: "441-Student",
        primTeacher: "01-SEP-2020",
        secnTeacher: "01-SEP-2020",
        remarks: "Text 1234",
        statusFlag: "Accepted",
        assignmentDesc:"",
        assiignmentFilename:"",
        answerDesc:"",
        answerFilename:"",
      },
      {
        id: "10",
        student: "441-Student",
        primTeacher: "01-SEP-2020",
        secnTeacher: "01-SEP-2020",
        remarks: "Text 1234",
        statusFlag: "Accepted",
        assignmentDesc:"",
        assiignmentFilename:"",
        answerDesc:"",
        answerFilename:""
      },
    ];
    this.updateTable();
  }
   updateTable() {
    $("#datatable").DataTable().destroy();
    setTimeout(() => {
      $("#datatable").DataTable({
        dom: 'Bfrtip',
        pagingType: 'simple_numbers',
        // responsive: true,
        // columnDefs: [
        //   { responsivePriority: 1, targets: 0 },
        //   { responsivePriority: 10001, targets: 4 },
        //   { responsivePriority: 2, targets: -2 }
        // ],
        // "columnDefs": [
        //   { "orderable": false, "targets": [1, 2] }
        // ],
        pageLength: 5,
        lengthChange: false,
        info: true,
        search: {
          searchPlaceholder: "Search",
        },
        paging: true,
        language: {
          search: "",
          searchPlaceholder: "Search",
        },
        buttons: [{
          extend: 'csvHtml5',
          text: '<span style="font-size: 3em; color: green;"><i class="fas fa-file-excel fa-sm"></i></span>',
          titleAttr: 'CSV',
          exportOptions: {
            columns: [0, 1, 2, 3, 4, 5, 6, 7]
          }
        }],
      });
    }, 1);
  }
  rejectAssignmentRequest(){
    
  }
  approveAssignmentRequest(){

  }
}
